import { Element } from "./Element";
import { Root } from "./Root";
import { Row } from "./Row";
import { SubTitle } from "./SubTitle";
import { Title } from "./Title";

export const Body = {
    Root: Root,
    Element: Element,
    Title: Title,
    SubTitle: SubTitle,
    Row: Row
}
